import { createColumnHelper } from "@tanstack/react-table";
import { NOT_APPLICABLE, marketingSalesColumnHeaderConstants } from "../../constants";

const {
  TITLE,
  SENT,
  STORE,
  OPENED,
  CLICKED,
  ORDERS,
  REVENUE,
  DELIVERED,
  EMAIL_STATS,
  TEXTS_MSGS_STATS,
  INDIVIDUAL_CAMPAIGNS,
} = marketingSalesColumnHeaderConstants;

//static headers for data table
const columnHelper = createColumnHelper();

export const MARKETING_SALES_COLUMNS = [
  {
    header: () => INDIVIDUAL_CAMPAIGNS,
    id: INDIVIDUAL_CAMPAIGNS,
    columns: [
      columnHelper.accessor("campaignTitle", {
        header: () => TITLE,
      }),
      columnHelper.accessor("restaurantTitle", {
        header: () => STORE,
      }),
    ],
  },

  {
    header: () => EMAIL_STATS,
    id: EMAIL_STATS,
    columns: [
      columnHelper.accessor("emailsCount", {
        header: () => SENT,
      }),
      columnHelper.accessor("emailDelivered", {
        header: () => DELIVERED,
      }),
      columnHelper.accessor("emailOpened", {
        header: () => OPENED,
      }),
      columnHelper.accessor("emailClicked", {
        header: () => CLICKED,
      }),
    ],
  },
  {
    header: () => TEXTS_MSGS_STATS,
    id: TEXTS_MSGS_STATS,
    columns: [
      columnHelper.accessor("smsCount", {
        header: () => SENT,
      }),
      columnHelper.accessor("smsDeliveredCount", {
        header: () => DELIVERED,
      }),
    ],
  },
  columnHelper.accessor("totalCampaignOrders", {
    header: () => ORDERS,
  }),
  columnHelper.accessor("totalRevenue", {
    header: () => REVENUE,
    cell: ({ row }) => {
      const totalRevenueData = row.original.totalRevenue;
      return totalRevenueData ? `$${totalRevenueData}` : NOT_APPLICABLE;
    },
  }),
];
